import {FC, ReactNode} from 'react'
import styles from './ProcedureCategoryTabs.scss'

interface Props {
  children: ReactNode
}

export const ProcedureCategoryTabs: FC<Props> = ({children}) => <div className={styles.tabs}>{children}</div>
